<div class="warning-banner-container">
  <div class="content">
    <div class="header">
      <div class="icon" *ngIf="showIcon">
        <ng-content select="[icon]"></ng-content>
      </div>
      {{ header }}
      <div class="close" *ngIf="closable">
        <ng-content select="[close]"></ng-content>
      </div>
    </div>
    <div class="body">{{ body }}</div>
  </div>
</div>
